/* BICI A EULO · bae-palillos
   Transición del visor del configurador: un par de palillos chinos barre la escena y va
   descubriendo el montaje nuevo, dejando un rastro de polvo de tinta.
   - No toca bae-studio.js: observa los cambios de src / hidden de las capas y de data-frame.
   - Todos los cambios del mismo clic (un kit cambia 5 capas) van en un solo barrido.
   - Alterna la dirección (izq→der, der→izq) en cada cambio.
   - Espera a que la capa nueva esté decodificada antes de barrer (no hay huecos en blanco).
   - Con "reducir movimiento" activado: fundido corto, sin palillos. */
(function () {
  'use strict';
  if (window.__baePalillos) return;
  window.__baePalillos = 1;

  var stage = document.querySelector('[data-stage-bike]');
  if (!stage || !window.MutationObserver) return;

  var DUR = 680;        // ms del barrido
  var TILT = 7;         // grados de inclinación de los palillos
  var OVER = 10;        // % que se pasan por cada lado
  var LOAD_MAX = 1500;  // ms máximos esperando la imagen nueva
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dir = 1, run = null, cache = {};

  /* ---------- estilos ---------- */
  var css =
    '.bae-pal{position:absolute;inset:0;pointer-events:none;z-index:90;opacity:0}' +
    '.bae-pal.is-on{opacity:1}' +
    '.bae-pal__sticks,.bae-pal__mist{position:absolute;top:-12%;height:124%;will-change:left,transform}' +
    '.bae-pal__sticks{width:9%;min-width:34px;filter:drop-shadow(0 6px 8px rgb(28 28 33 / .28))}' +
    '.bae-pal__sticks svg{display:block;width:100%;height:100%}' +
    '.bae-pal__mist{width:16%;opacity:.9}' +
    '.bae-pal__dot{position:absolute;border-radius:50%;pointer-events:none;will-change:transform,opacity}' +
    '.bae-pal-ghost{pointer-events:none}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---------- palillos (SVG, sin fondo) ----------
     Laca roja con banda amarilla arriba y punta de bambú. Forman una V que se cierra abajo:
     la línea central de la V es el borde entre la bici vieja y la nueva. */
  function stick(x1, x2, id) {
    // x1: centro arriba, x2: centro abajo. Afinado de 11 a 4,4 unidades.
    var t = 5.5, b = 2.2, H = 600, cut = 250;
    var xc = x1 + (x2 - x1) * (cut / H), wc = t + (b - t) * (cut / H);
    return '' +
      '<polygon points="' + (x1 - t) + ',0 ' + (x1 + t) + ',0 ' + (xc + wc) + ',' + cut + ' ' + (xc - wc) + ',' + cut + '" fill="url(#bpl' + id + ')"/>' +
      '<polygon points="' + (xc - wc) + ',' + cut + ' ' + (xc + wc) + ',' + cut + ' ' + (x2 + b) + ',' + H + ' ' + (x2 - b) + ',' + H + '" fill="url(#bpb' + id + ')"/>' +
      '<rect x="' + (x1 - t) + '" y="34" width="' + (2 * t) + '" height="10" fill="#FFD21F"/>' +
      '<rect x="' + (x1 - t) + '" y="50" width="' + (2 * t) + '" height="3" fill="#FFD21F"/>' +
      '<line x1="' + (x1 - t * 0.35) + '" y1="4" x2="' + (xc - wc * 0.35) + '" y2="' + (cut - 4) + '" stroke="#fff" stroke-opacity=".35" stroke-width="1"/>';
  }
  function grads(id) {
    return '' +
      '<linearGradient id="bpl' + id + '" x1="0" x2="1"><stop offset="0" stop-color="#9E120C"/><stop offset=".45" stop-color="#E2231A"/><stop offset="1" stop-color="#B5160F"/></linearGradient>' +
      '<linearGradient id="bpb' + id + '" x1="0" x2="1"><stop offset="0" stop-color="#C9A86B"/><stop offset=".5" stop-color="#EAD3A0"/><stop offset="1" stop-color="#BF9C5E"/></linearGradient>';
  }
  var SVG = '<svg viewBox="0 0 60 600" preserveAspectRatio="none" aria-hidden="true"><defs>' +
    grads('a') + grads('b') + '</defs>' + stick(16, 27.5, 'a') + stick(44, 32.5, 'b') + '</svg>';

  if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
  var fx = document.createElement('div');
  fx.className = 'bae-pal';
  fx.setAttribute('aria-hidden', 'true');
  fx.innerHTML = '<div class="bae-pal__mist"></div><div class="bae-pal__sticks">' + SVG + '</div>';
  var mist = fx.firstChild, sticks = fx.lastChild;

  /* ---------- utilidades ---------- */
  function layers() {
    return Array.prototype.slice.call(stage.querySelectorAll('.bae-bike__layer[data-slot]'));
  }
  function snap() {
    layers().forEach(function (el) {
      if (el.hidden) return;
      var cs = getComputedStyle(el);
      cache[el.getAttribute('data-slot')] = { t: cs.transform, o: cs.transformOrigin };
    });
  }
  function ease(p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
  function ready(el) {
    if (!el || el.hidden || !el.getAttribute('src')) return Promise.resolve();
    var p = el.decode ? el.decode().catch(function () {}) : new Promise(function (r) {
      if (el.complete && el.naturalWidth) return r();
      el.addEventListener('load', r, { once: true });
      el.addEventListener('error', r, { once: true });
    });
    return Promise.race([p, new Promise(function (r) { setTimeout(r, LOAD_MAX); })]);
  }
  function makeGhost(el, src, useCache) {
    var slot = el.getAttribute('data-slot'), g = document.createElement('img');
    g.className = 'bae-bike__layer bae-pal-ghost';
    g.alt = '';
    g.decoding = 'sync';
    if (el.getAttribute('width')) g.setAttribute('width', el.getAttribute('width'));
    if (el.getAttribute('height')) g.setAttribute('height', el.getAttribute('height'));
    g.style.zIndex = el.style.zIndex;
    var c = cache[slot];
    if (!useCache && !el.hidden) {
      var cs = getComputedStyle(el);
      c = { t: cs.transform, o: cs.transformOrigin };
    }
    if (c) { g.style.transform = c.t; g.style.transformOrigin = c.o; }
    g.src = src;
    el.parentNode.insertBefore(g, el.nextSibling); // detrás en el DOM: querySelector sigue encontrando la capa real
    return g;
  }

  /* ---------- geometría del barrido ----------
     x = posición de la línea central (% del ancho). La línea va inclinada como los palillos. */
  var L = -60, R = 160;
  function clips(x, d, hx) {
    var top = x + d * hx, bot = x - d * hx;
    var left = 'polygon(' + L + '% 0,' + top + '% 0,' + bot + '% 100%,' + L + '% 100%)';
    var right = 'polygon(' + top + '% 0,' + R + '% 0,' + R + '% 100%,' + bot + '% 100%)';
    // d = 1 (izq→der): lo barrido (nuevo) queda a la izquierda
    return d === 1 ? { neu: left, old: right } : { neu: right, old: left };
  }

  function spawnDust(x, d, hx) {
    var n = 3 + (Math.random() * 3 | 0);
    for (var i = 0; i < n; i++) {
      var yy = 0.08 + Math.random() * 0.84;
      var px = x + d * hx * (1 - 2 * yy);
      var s = 2.5 + Math.random() * 5;
      var dot = document.createElement('span');
      var r = Math.random();
      dot.className = 'bae-pal__dot';
      dot.style.cssText = 'left:' + px + '%;top:' + (yy * 100) + '%;width:' + s + 'px;height:' + (r > 0.75 ? s * 0.45 : s) + 'px;background:' +
        (r < 0.5 ? 'rgb(28 28 33 / .5)' : r < 0.75 ? 'rgb(28 28 33 / .25)' : r < 0.92 ? '#E2231A' : '#FFD21F');
      fx.appendChild(dot);
      var dx = -d * (16 + Math.random() * 46), dy = (Math.random() - 0.35) * 26;
      var a = dot.animate([
        { transform: 'translate(-50%,-50%) scale(1)', opacity: 0.95 },
        { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(.3) rotate(' + (Math.random() * 120 | 0) + 'deg)', opacity: 0 }
      ], { duration: 520 + Math.random() * 380, easing: 'cubic-bezier(.2,.7,.3,1)' });
      a.onfinish = (function (el) { return function () { el.remove(); }; })(dot);
    }
  }

  function finish() {
    if (!run) return;
    cancelAnimationFrame(run.raf);
    run.ghosts.forEach(function (g) { g.remove(); });
    run.enter.forEach(function (el) { el.style.clipPath = ''; el.style.webkitClipPath = ''; });
    fx.classList.remove('is-on');
    run = null;
    snap();
  }

  function sweep(ghosts, enter) {
    var d = dir; dir = -dir;
    var k = stage.offsetHeight / Math.max(1, stage.offsetWidth);
    var hx = 50 * k * Math.tan(TILT * Math.PI / 180);
    var x0 = d === 1 ? -OVER : 100 + OVER, x1 = d === 1 ? 100 + OVER : -OVER;
    var me = run = { ghosts: ghosts, enter: enter, raf: 0 };

    function apply(x) {
      var c = clips(x, d, hx);
      ghosts.forEach(function (g) { g.style.clipPath = c.old; g.style.webkitClipPath = c.old; });
      enter.forEach(function (el) { el.style.clipPath = c.neu; el.style.webkitClipPath = c.neu; });
      sticks.style.left = x + '%';
      sticks.style.transform = 'translateX(-50%) rotate(' + (d * TILT) + 'deg)';
      mist.style.left = x + '%';
      mist.style.transform = 'translateX(' + (d === 1 ? '-100%' : '0') + ') rotate(' + (d * TILT) + 'deg)';
      mist.style.background = 'linear-gradient(' + (d === 1 ? 'to left' : 'to right') +
        ',rgb(28 28 33 / .10),rgb(226 35 26 / .05) 35%,transparent)';
    }
    apply(x0); // estado inicial antes del primer pintado: todo viejo

    Promise.all(enter.map(ready)).then(function () {
      if (run !== me) return;
      fx.classList.add('is-on');
      var t0 = performance.now(), lastDust = 0;
      (function frame(now) {
        if (run !== me) return;
        var p = Math.min(1, (now - t0) / DUR), x = x0 + (x1 - x0) * ease(p);
        apply(x);
        if (now - lastDust > 34 && x > -2 && x < 102) { spawnDust(x, d, hx); lastDust = now; }
        if (p < 1) me.raf = requestAnimationFrame(frame);
        else finish();
      })(t0);
    });
  }

  function fade(ghosts) {
    var me = run = { ghosts: ghosts, enter: [], raf: 0 };
    ghosts.forEach(function (g) {
      g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-out', fill: 'forwards' });
    });
    setTimeout(function () { if (run === me) finish(); }, 210);
  }

  /* ---------- observador ---------- */
  var mo = new MutationObserver(function (list) {
    var info = new Map(), frameChanged = false;
    list.forEach(function (m) {
      if (m.target === stage && m.attributeName === 'data-frame') {
        if (m.oldValue !== stage.getAttribute('data-frame')) frameChanged = true;
        return;
      }
      var el = m.target;
      if (!el.classList || !el.classList.contains('bae-bike__layer') || el.classList.contains('bae-pal-ghost')) return;
      var rec = info.get(el) || {};
      if (m.attributeName === 'src' && !('src' in rec)) rec.src = m.oldValue;
      if (m.attributeName === 'hidden' && !('hidden' in rec)) rec.hidden = m.oldValue;
      info.set(el, rec);
    });
    if (frameChanged) layers().forEach(function (el) { if (!info.has(el)) info.set(el, {}); });
    if (!info.size) return;

    finish(); // si había un barrido a medias, se cierra al instante

    var ghosts = [], enter = [];
    info.forEach(function (rec, el) {
      var wasVisible = 'hidden' in rec ? rec.hidden === null : !el.hidden;
      var oldSrc = 'src' in rec ? rec.src : el.getAttribute('src');
      var nowVisible = !el.hidden, newSrc = el.getAttribute('src');
      var changed = frameChanged || oldSrc !== newSrc || wasVisible !== nowVisible;
      if (!changed || (!wasVisible && !nowVisible)) return;
      if (wasVisible && oldSrc) ghosts.push(makeGhost(el, oldSrc, frameChanged));
      if (nowVisible && newSrc) enter.push(el);
    });
    if (!ghosts.length && !enter.length) return;

    if (reduce) fade(ghosts);
    else sweep(ghosts, enter);
  });

  function start() {
    stage.appendChild(fx);
    snap();
    mo.observe(stage, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['src', 'hidden', 'data-frame'] });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (!run) snap(); }, 200); });
  }
  // bae-studio.js pinta el montaje inicial antes; empezamos a observar después, así la carga no se anima.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
